<!--
Copyright 2022 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license. See LICENSE.md in the project root for license information.
-->

<mat-sidenav-container class="appcontent-container" autosize>
  <mat-sidenav #sidenav mode="side" [(opened)]="isSidebarOpen" class="appbarmenu-container">
    <div class="sidenav-content-wrapper">
    <mat-toolbar class="sidenav-header" title="Exit Administration" (click)="exitAdmin()">
      <a class="nolink">
        <div class="cssLayoutRowStartCenter">
          <mat-icon class="icon-35px crucible-icon-gallery" svgIcon="crucible-icon-gallery"></mat-icon>
          <h2 class="icon-text">Administration</h2>
        </div>
      </a>
    </mat-toolbar>
    <mat-list class="appitems-container">
      @if (canViewCollections || canCreateCollections) {
      <mat-list-item id="wrapper showhand" (click)="gotoSection(section.collections)"
        [ngClass]="getSelectedClass(section.collections)">
        <mat-icon matListItemIcon class="mat-list-item-icon" fontIcon="mdi-focus-field"></mat-icon>
        Collections
        <button aria-labelledby="'Collections" mat-icon-button class="pull-right">
          <mat-icon fontIcon="mdi-menu-right"></mat-icon>
        </button>
      </mat-list-item>
      }
      @if (canViewExhibits || canCreateExhibits) {
      <mat-list-item id="wrapper showhand" (click)="gotoSection(section.exhibits)"
        [ngClass]="getSelectedClass(section.exhibits)">
        <mat-icon matListItemIcon class="mat-list-item-icon" fontIcon="mdi-monitor-dashboard"></mat-icon>
        Exhibits
        <button aria-labelledby="'Exhibits'" mat-icon-button class="pull-right">
          <mat-icon fontIcon="mdi-menu-right"></mat-icon>
        </button>
      </mat-list-item>
      }
      @if (canViewUsers) {
      <mat-list-item [ngClass]="getSelectedClass(section.users)" id="wrapper showhand"
        (click)="gotoSection(section.users)">
        <mat-icon matListItemIcon class="mat-list-item-icon" fontIcon="mdi-account"></mat-icon>
        Users
        <button aria-labelledby="usersText" mat-icon-button class="pull-right">
          <mat-icon fontIcon="mdi-menu-right"></mat-icon>
        </button>
      </mat-list-item>
      }
      @if (canViewRoles) {
      <mat-list-item [ngClass]="getSelectedClass(section.roles)" id="wrapper showhand"
        (click)="gotoSection(section.roles)">
        <mat-icon matListItemIcon class="mat-list-item-icon" fontIcon="mdi-lock"></mat-icon>
        Roles
        <button aria-labelledby="rolesText" mat-icon-button class="pull-right">
          <mat-icon fontIcon="mdi-menu-right"></mat-icon>
        </button>
      </mat-list-item>
      }
      @if (canViewGroups) {
      <mat-list-item [ngClass]="getSelectedClass(section.groups)" id="wrapper showhand"
        (click)="gotoSection(section.groups)">
        <mat-icon matListItemIcon class="mat-list-item-icon" fontIcon="mdi-account-group"></mat-icon>
        Groups
        <button aria-labelledby="groupsText" mat-icon-button class="pull-right">
          <mat-icon fontIcon="mdi-menu-right"></mat-icon>
        </button>
      </mat-list-item>
      }
    </mat-list>
    @if (!hideTopbar) {
    <div class="app-versions">
      Versions: UI {{ uiVersion }}, API {{ apiVersion }}
    </div>
    }
    @if (hideTopbar) {
    <div class="app-versions">
      Versions: UI {{ uiVersion }}, API {{ apiVersion }}
    </div>
    }
    @if (!hideTopbar) {
    <img class="crucible-logo" [src]="
        (theme$ | async) === 'light-theme'
          ? 'assets/img/crucible-logo-light.png'
          : 'assets/img/crucible-logo-dark.png'
      " />
    }
    </div>
  </mat-sidenav>
  <mat-sidenav-content>
    @if (!hideTopbar) {
    <app-topbar [title]="displayedSection" [topbarView]="TopbarView.GALLERY_ADMIN"></app-topbar>
    }
    @if ((canViewCollections || canCreateCollections) && displayedSection === section.collections) {
    <span>
      <app-admin-collections></app-admin-collections>
    </span>
    }
    @if ((canViewExhibits || canCreateExhibits) && displayedSection === section.exhibits) {
    <span>
      <app-admin-exhibits [userList]="userList | async">
      </app-admin-exhibits>
    </span>
    }
    @if (canViewUsers && displayedSection === section.users) {
      <app-admin-users></app-admin-users>
    }
    @if (canViewRoles && displayedSection === section.roles) {
    <span>
      <app-admin-roles></app-admin-roles>
    </span>
    }
    @if (canViewGroups && displayedSection === section.groups) {
    <span>
      <app-admin-groups></app-admin-groups>
    </span>
    }
  </mat-sidenav-content>
</mat-sidenav-container>
